import type { IconProps } from "@/lib/icons";

export const Icons = {
  logo: (props: IconProps) => (
    <svg
      {...props}
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M778 190.5C787.448 190.313 796.895 190.4 806.334 190.761C871.754 193.534 953.917 277.396 981.731 339.226C984.699 345.83 989.163 354.931 988.802 362.133C988.229 363.117 986.777 365.502 985.139 364.725C970.417 357.672 949.189 356.395 933.279 359.789C859.089 375.609 793.877 433.482 730.5 473.5C642.496 529.064 566.219 592.495 479.57 649.885C405.569 698.9 327.856 750.801 243 778C175.426 797.68 95.2522 778.604 54.4507 713.563C50.3221 706.979 44.3348 697.227 46.1592 689.337C48.1015 687.925 59.76 690.405 63.841 688.075C91.2161 672.472 120.3 653.442 143.5 632.5C174.536 604.127 205.029 575.888 236.5 548C366.556 433.477 487.784 265.304 655.138 212.537C696.406 199.528 734.962 193.166 778 190.5Z"
        fill="currentColor"
      />
      <path
        d="M997.138 424.011C1000.79 424.365 1003.45 424.395 1006.23 427.111C1010.06 430.847 1011.01 438.816 1010.79 443.886C1007.01 533.276 910.804 645.856 851.325 704.679C727.409 827.232 539.171 951.003 359.211 950.005C301.435 949.679 245.729 933.387 199.528 898.658C187.784 889.832 175.321 880.627 164.971 870.142C155.189 860.76 119.243 822.731 121.969 811.178L123.746 810.313C129.392 814.073 141.229 828.67 152.519 836.587C199.464 869.524 266.764 861.828 319.689 846.736C491.302 797.789 657.573 675.378 796.778 567.043L899.159 485.882C922.705 467.387 968.086 429.508 997.138 424.011Z"
        fill="currentColor"
      />
      <path
        d="M585.698 44.5612C614.36 42.7447 648.033 45.5774 678.274 50.8601C747.932 63.0289 818.587 97.5053 863.966 152.922C866.189 155.633 870.371 163.822 869.762 166.969L868.43 167.17C859.45 161.895 851.889 152.42 843.658 146.16C757.671 80.7597 624.285 121.608 537.698 165.809C400.742 235.72 287.09 348.174 188.286 464.138C179.112 474.121 169.09 486.794 160.25 497.448L98.7234 572.602C85.4173 588.722 72.0178 605.23 57.0444 619.763C50.6574 625.959 35.7334 637.716 27.664 628.77C16.6057 616.511 15.5833 594.23 14.155 578.349C13.1714 567.411 14.4576 553.504 16.8421 542.742C22.2588 522.894 32.6104 500.872 41.7375 482.467C83.7314 398.921 137.109 321.59 200.347 252.679C299.613 145.294 434.785 50.6336 585.698 44.5612Z"
        fill="currentColor"
      />
      <path
        d="M1009.33 545.011C1015.01 548.667 1012.21 567.908 1011.53 574.127C1006.03 621.294 992.947 667.263 972.815 710.281C863.563 946.513 563.033 1077.12 321.499 965.683C315.158 962.449 306.95 958.503 301.822 953.56L302.085 952.917C309.716 952.697 324.572 959.463 332.731 961.313C603.685 1022.68 880.36 833.194 988.774 591.2C995.09 577.087 1001.56 557.935 1009.33 545.011Z"
        fill="currentColor"
      />
      <path
        d="M484.451 17.2522C529.164 15.8775 576.132 20.2163 618.724 34.6339C623.646 36.3025 634.115 39.8467 637.769 43.1628L637.822 44.4962C634.106 44.5349 620.564 41.3367 615.686 40.5191C601.474 38.2493 587.2 36.3598 572.883 34.8531C478.745 25.261 379.191 49.7274 298.269 97.4202C195.886 157.76 111.793 261.634 63.8562 369.056C49.861 400.137 36.4091 432.337 25.6006 464.727C23.6695 470.516 21.3476 483.03 16.6605 486.011L15.3494 485.164C14.092 481.654 13.9696 477.999 13.8895 474.259C11.6714 370.534 64.6188 253.277 133.989 178.28C227.366 77.3287 347.816 22.8328 484.451 17.2522Z"
        fill="currentColor"
      />
    </svg>
  ),
  boond: (props: IconProps) => (
    <svg
      {...props}
      width="240"
      height="240"
      viewBox="0 0 240 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="240" height="240" fill="var(--brand-boond)" />
      <path
        d="M174.543 47.1823C175.463 48.3528 181.654 88.2845 182.474 93.1803C183.002 96.3324 184.41 103.723 185.097 107.227C186.16 112.658 186.808 120.58 188.128 125.698C170.637 142.575 153.765 160.278 136.404 177.306C130.896 182.707 125.345 188.273 119.995 193.82C115.065 188.11 106.28 179.955 100.691 174.33L61.0352 134.704C58.0098 131.658 55.1638 128.739 52 125.832C53.3847 119.764 54.0292 111.567 55.3436 105.239C58.2025 91.4741 59.9784 77.4113 62.2727 63.5389C63.178 58.0644 64.5972 52.445 65.3366 47C66.6159 49.0773 68.6598 51.2773 70.2693 53.1636L78.5908 62.8449L105.927 94.8523C109.642 99.2007 117.025 107.196 120.019 111.554C124.102 106.153 129.568 100.277 134.003 95.0553L159.656 64.9489L167.769 55.61C170.053 53.003 172.801 50.1088 174.543 47.1823Z"
        fill="var(--brand-boond-foreground)"
      />
    </svg>
  ),
  google: (props: IconProps) => (
    <svg
      {...props}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.56 9.17916C16.56 8.62075 16.5099 8.08382 16.4168 7.56836H9V10.6146H13.2382C13.0556 11.5989 12.5008 12.433 11.6668 12.9914V14.9673H14.2118C15.7009 13.5963 16.56 11.5775 16.56 9.17916Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00028 16.8748C11.1265 16.8748 12.9091 16.1697 14.2121 14.967L11.667 12.991C10.9619 13.4635 10.0598 13.7427 9.00028 13.7427C6.94919 13.7427 5.21312 12.3574 4.59386 10.4961H1.96289V12.5364C3.25869 15.1102 5.92187 16.8748 9.00028 16.8748Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.59358 10.4962C4.43608 10.0237 4.3466 9.519 4.3466 8.99997C4.3466 8.48094 4.43608 7.97622 4.59358 7.50372V5.46338H1.96262C1.42926 6.5265 1.125 7.72923 1.125 8.99997C1.125 10.2707 1.42926 11.4734 1.96262 12.5365L4.59358 10.4962Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.00028 4.2571C10.1565 4.2571 11.1945 4.65443 12.0107 5.43477L14.2693 3.17608C12.9056 1.90534 11.1229 1.125 9.00028 1.125C5.92187 1.125 3.25869 2.88972 1.96289 5.4634L4.59386 7.50375C5.21312 5.64238 6.94919 4.2571 9.00028 4.2571Z"
        fill="#EA4335"
      />
    </svg>
  ),
  boondIcon: (props: IconProps) => (
    <svg
      {...props}
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M150.031 15.1863C151.044 16.3821 157.866 57.1787 158.769 62.1806C159.351 65.401 160.903 72.9516 161.66 76.5319C162.832 82.0798 163.546 90.174 165 95.4029C145.726 112.645 127.135 130.732 108.004 148.128C101.936 153.646 95.8191 159.333 89.9236 165C84.4919 159.167 74.8116 150.835 68.6526 145.088L24.9559 104.604C21.6223 101.492 18.4862 98.5098 15 95.5394C16.5258 89.3402 17.236 80.9651 18.6843 74.5004C21.8345 60.4374 23.7914 46.0701 26.3195 31.8972C27.3171 26.304 28.8809 20.5629 29.6957 15C31.1052 17.1223 33.3575 19.37 35.131 21.2971L44.3004 31.1881L74.4221 63.8889C78.5163 68.3314 86.6512 76.5001 89.9507 80.9527C94.4493 75.4338 100.473 69.4315 105.359 64.0962L133.627 33.3377L142.566 23.7965C145.082 21.1331 148.111 18.1761 150.031 15.1863Z"
        fill="var(--brand-boond)"
      />
    </svg>
  ),
};
